import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PostSkeletonComponent } from "../../../skeletons/post-skeleton/post-skeleton.component";
import { LoaderComponent } from "../../../shared/loader/loader.component";

@Component({
  selector: 'empty-layout',
  standalone: true,
  imports: [RouterOutlet, NgIf, PostSkeletonComponent, LoaderComponent],
  templateUrl: './empty.component.html',
  styleUrl: './empty.component.scss'
})
export class EmptyLayout {
 @Input() isLoading: boolean = true
}
